<div
    class="container-template h-100 d-flex align-items-normal justify-content-center flex-column"
    [ngClass]="containerSizeClass === 'normal' ? 'container-template-large' : 'container-template-small'"
>
    <div class="rnpl-copy">
        <app-logo-payment-method [paymentMethodName]="creditPaymentMethod" width="13em" alt="SprintPay logo" />
        <app-rnpl-slogan></app-rnpl-slogan>
    </div>
    <app-credit-amount [creditAmount]="cargoCredit?.balance?.avaliableCredit || 0" [externalMessage]="externalMessage">
        <ng-content />
    </app-credit-amount>
</div>
